import { CtaProps } from './cta';
import { FeatureListProps } from './feature-list';
import { HeroProps } from './hero';
import { ProductListProps } from './product-list';
import { RichTextBlockProps } from './rich-text-block';

export { default as ContentfulHomepageHero } from "./hero"
export { default as ContentfulHomepageFeatureList } from "./feature-list"
export { default as ContentfulHomepageCta } from "./cta"
export { default as ContentfulHomepageProductList } from "./product-list"
export { default as ContentfulRichTextBlock } from "./rich-text-block"

export type SectionProps =
  | HeroProps
  | FeatureListProps
  | CtaProps
  | ProductListProps
  | RichTextBlockProps

type Blocktypes =
  | "ContentfulHomepageHero"
  | "ContentfulHomepageFeatureList"
  | "ContentfulHomepageCta"
  | "ContentfulHomepageProductList"
  | "ContentfulRichTextBlock"

type WithBlocktype<B = Blocktypes, P = SectionProps> = {
  id: string
  contentful_id: string
  blockType: B
} & P

export type HomepageBlock =
  | WithBlocktype<"ContentfulHomepageHero", HeroProps>
  | WithBlocktype<"ContentfulHomepageFeatureList", FeatureListProps>
  | WithBlocktype<"ContentfulHomepageCta", CtaProps>
  | WithBlocktype<"ContentfulHomepageProductList", ProductListProps>
  | WithBlocktype<"ContentfulRichTextBlock", RichTextBlockProps>
